<template>
  <a :href="`#section-${item.sectionIndex}`"
     :data-id="item.id"
     :data-item-index="item.index"
     :data-section-index="item.sectionIndex"
     class="scrollactive-item sidebar-link"
     @click="onClick">
    <div>{{ flightDateLabel }}</div>
    <div>{{ organizationLabel }}</div>
  </a>
</template>

<script>
import moment from 'moment'

export default {
  props: ['item', 'index'],

  computed: {
    flightDateLabel () {
      return moment(this.item.value.flightDate).utc(true).format('YYYY-MM-DD')
    },
    organizationLabel () {
      return this.item.value['orderData.organization']
    }
  },
  methods: {
    onClick () {
      this.debug && console.log('group item: %o', this.item)
      this.$emit('click:item', this.item)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/flight-orders/scrolled/GroupDateOrg.vue